import CustomerCSP from "../../models/csp/CustomerCSP";
import service from "../service";
import baseEndpointPartnerCenter from "./servicePartnerCenter";

const endpoint = baseEndpointPartnerCenter + "/customers";

export default {
  components: { service: service },
  methods: {
    async getCustomersCSP(): Promise<CustomerCSP[]> {
      const response = await service.methods.getEndpointAsync(endpoint);
      return response.items.map(
        customer =>
          new CustomerCSP({
            id: customer.id,
            name: customer.companyProfile.companyName
          })
      );
    }
  }
};
